import { FORMATTER_DEFAULT } from '~/app/market-config/market-formatter';
import { CarConfiMarketConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import {
	CMS_DEFAULT_HIDE_STANDARD_ACCESSORIES,
	CMS_DEFAULT_STOCKCAR_DISCLAIMER,
	CMS_DEFAULT_STOCKCAR_GEOFILTER,
	CMS_DEFAULT_STOCKCAR_PRICE_DISCLAIMER,
	CMS_DEFAULT_STOCKCAR_PRICE_MAX,
	CMS_DEFAULT_STOCKCAR_PRICE_MIN,
	CMS_DEFAULT_STOCKCAR_SUBHEADER,
	JETSTREAM_SERVER_EU,
} from '~/app/models/constans';
import { NgcCarIdentifier } from '~/app/utils/graphql-sub-types';

export default function DefaultMarket(carlineId: string) {
	const confi: CarConfiMarketConfiguration = {
		stockCarConfig: {
			enabled: false,
			geoFilter: CMS_DEFAULT_STOCKCAR_GEOFILTER,
			disclaimer: CMS_DEFAULT_STOCKCAR_DISCLAIMER,
			subheader: CMS_DEFAULT_STOCKCAR_SUBHEADER,
			url: '',
			priceFilter: { min: CMS_DEFAULT_STOCKCAR_PRICE_MIN, max: CMS_DEFAULT_STOCKCAR_PRICE_MAX },
			pricedisclaimer: CMS_DEFAULT_STOCKCAR_PRICE_DISCLAIMER,
		},
		hasJetStream: true,
		JetStreamServerUrl: JETSTREAM_SERVER_EU,
		combinations: ['trimLine', 'packages', 'paint', 'rims', 'headlights', 'interior', 'steeringWheels'],
		printServiceUrl: { url: '', pathParams: {}, queryParams: [] },
		specialOfferUrl: '',
		deliveryCostUrl: '',
		showEECLabelEngine: true,
		hasTechnicalDataEnabled: true,
		showEECLabel: false,
		wltpInfo: null,
		configuratorOptions: [],
		defaultOption: '',
		packagesFilter: {
			filterByFeatureState: ['available'],
			filterByGroupIds: {
				groupIds: ['Linien_Pakete'],
			},
		},
		carIdentifier: null as unknown as NgcCarIdentifier, // Should be set from default car identifier
		carlineId,
		financingInput: null, // when set to null, the system should return the most appropriate product automatically
		showCaESummaryText: true,
		engineCardKeyfacts: ['electricRangeCombined', 'consumption', 'emissionCO2'],
		getFormatter: FORMATTER_DEFAULT,
		pricePartsOrder: [],
		pricePartsOrderFunction(a, b) {
			return b.price.value - a.price.value;
		},
		uiPreferences: {
			prices: {
				totalPriceFrom: 'total',
				hiddenPriceParts: [
					'financeableTotal',
					'total',
					'taxTotal',
					'taxTotalWeight',
					'totalRate',
					'totalWithoutIncentives',
					'importCharge',
					'destinationCharge',
				],
				vatConfig: {
					feature: 'inclusive',
					trimlineAndEngine: 'inclusive',
					totalPrice: 'inclusive',
					priceParts: {},
				},
			},
		},
		financeDomain: '', // there is no common finance-domain for markets
		enableFinancingServices: true,
		financingDisclaimer: ['productDisclaimer'],
		showFinancingDisclaimerInDialogs: true,
		hideMonthlyRates: false,
		enablePartsRateCalculation: true,
		enablePriceDisclaimer: false,
		hideStandardAccessories: CMS_DEFAULT_HIDE_STANDARD_ACCESSORIES,
		useStaticPriceDateRemark: false,
		useSummaryAlternativePriceDateRemark: false,
		hideConsumptionEmissionEngineName: false,
		enableDynamicSummaryFooterButton: false,
		showPrices: true,
		showEnginePriceDisclaimer: false,
		nextBestActions: [],
		additionalPrimaryNba: undefined,
		summaryFooterCta: { icon: '', description: '', labelText: '', trackingName: '', url: '', target: '_blank' },
		secondarySummaryCta: undefined,
		disablePdfNba: false,
		enableIncentives: false,
		showPricesWithFees: false,
		useBasePriceWithFees: false,
		omnibus: { enabled: false, url: '' },
		showConsumptionEmissionTechData: true,
		displayOnlyPackageCat: false,
		showPsInTechData: true,
		useIframe: true,
		enableEngineFilter: true,
		enable3d: true,
		globalDisclaimer: undefined,
		categoryDisclaimers: undefined,
		leanCheckoutEnabled: false,
		showEfficiencyClass: false,
		showFeesOnSummaryPage: false,
	};

	return confi;
}
